export default {
  "bbt.gnav.menu": "Menu",
  "bbt.gnav.eventProgram": "イベント・プログラム",
  "bbt.gnav.news": "ニュース",
  "bbt.gnav.report": "レポート",
  "bbt.gnav.supporter": "サポーター",
  "bbt.gnav.about": "BBTを知る",
  "bbt.gnav.linkj": "LINK-J",
  "bbt.gnav.cic": "CIC",
  "bbt.gnav.mri": "MRI",
} as const;
